export interface GiftCardTransactionResponseDto {
  success: boolean;
  result: any;
}
